<div class="text text--max-line-length">

    {#if title}
    <h2>{title}</h2>
    {/if}

    {#if subtitle}
    <h3>{subtitle}</h3>
    {/if}

    {#if content}
    <Paragraph content={content} />
    {/if}

    {#if software.length}
    <h4>Benutzte Software:</h4>

    <Software shorthands={software} />
    {/if}
    
</div>

<script>
    // components
    import Paragraph from 'components/Paragraph.html'

    // views
    import Software from 'views/compounds/Software.html'

    export default {
        components: {
            Paragraph,
            Software
        },
        data() {
            return {
                title: '',
                subtitle: '',
                content: '',
                software: []
            }
        }
    }
</script>